import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { getUid } from "../redux/authSlice";
import { getData } from "../utils/firebase";
import { User } from "../types/user";

/** Firebase returns users keyed by uid; value is partial User with staffEmail */
type UserResponse = Record<string, Partial<User>>;

const useUsersQuery = (refetchOnMount?: boolean): UseQueryResult<User[], Error> => {
  const uid = useSelector(getUid);

  return useQuery<User[], Error>({
    queryKey: ["users", uid],
    queryFn: async () => {
      const response = await getData(`dealers/${uid}/info/users`);
      const userResponse = response as UserResponse;
      const list: User[] = Object.entries(userResponse || {}).map(([key, item]) => ({
        uid: key,
        name: item.name ?? "",
        phoneNumber: item.phoneNumber ?? "",
        email: item.staffEmail ?? "",
        role: item.role ?? "staff",
        staffEmail: item.staffEmail ?? "",
        participatesInRoundRobin: item.participatesInRoundRobin ?? false,
        status: "active",
        isActive: item.isActive,
        presence: item.presence,
        notificationPreferences: item.notificationPreferences ?? {},
      }));
      return list?.filter((user) => user?.isActive);
    },
    enabled: !!uid,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnMount: refetchOnMount ? "always" : undefined,
  });
};

export default useUsersQuery;
